// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yJ7b","badges":"styles_badges__2Teiy"};